<template>
  <PresentationEditorGoogleSlideComponent />
</template>

<script>
import PresentationEditorGoogleSlideContainer from '@/containers/PresentationEditorGoogleSlide/PresentationEditorGoogleSlideContainer'
import PresentationEditorGoogleSlideComponent from '@/components-v2/presentation-editor/PresentationEditorGoogleSlideComponent.vue'

export default {
  components: {
    PresentationEditorGoogleSlideComponent:
      PresentationEditorGoogleSlideContainer(PresentationEditorGoogleSlideComponent),
  },
}
</script>
